'use client';

import { ApolloClient, ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import { PropsWithChildren } from 'react';
import { initializeGraphqlClient } from '@graphql/client/initializeGraphqlClient';

function makeClient(): ApolloClient {
  return initializeGraphqlClient({ mode: 'client' });
}

export function ApolloWrapper({ children }: PropsWithChildren) {
  return <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
}
